module.exports = __webpack_public_path__ + "static/media/5valkas_edited.55075269.jpg";